import { InjectionToken } from '@angular/core';

import { CreateAppointmentModalType } from '@lib/core/models/create-appointment.interface';

export interface ChatNavigationHandlers {
  /**
   * Navigate to member guarantees page with specific prescription highlighting
   * @param prescriptionId - ID of the specific prescription to highlight
   * @param userId - user ID to show guarantees for
   */
  navigateToPrescription?: (prescriptionId: string, userId: string) => void;

  /**
   * Switch to prescriptions tab in chat and highlight specific prescription (in-chat)
   * @param prescriptionId - ID of the specific prescription to highlight
   */
  switchToPrescriptionTab?: (prescriptionId: string) => void;

  /**
   * Open modal or navigate to create new prescription page
   */
  openCreatePrescriptionModal?: (userId: string) => void;

  /**
   * Open manual appointment creation modal
   * @param userId - user ID for the appointment
   * @param modalType - the type of modal to open (ManualCreation or BindToExisting)
   * @param metadata - optional chat metadata for pre-filling fields, can include prescription object
   */
  openCreateManualAppointmentModal?: (
    userId: string,
    modalType: CreateAppointmentModalType,
    metadata?: {
      prescriptionId: string;
      prescriptionName: string;
      partnerId?: string;
      locationId?: string;
    }
  ) => void;

  /**
   * Navigate to member profile page
   */
  navigateToMemberProfile?: (userId: string) => void;
}

export const CHAT_NAVIGATION_HANDLERS = new InjectionToken<ChatNavigationHandlers>('ChatNavigationHandlers', {
  providedIn: 'root',
  factory: () => ({
    // Default empty handlers - host app should provide actual implementations
    navigateToPrescription: () => console.warn('navigateToPrescription handler not implemented'),
    switchToPrescriptionTab: () => console.warn('switchToPrescriptionTab handler not implemented'),
    openCreatePrescriptionModal: () => console.warn('openCreatePrescriptionModal handler not implemented'),
    openCreateManualAppointmentModal: () => console.warn('openCreateManualAppointmentModal handler not implemented'),
    navigateToMemberProfile: () => console.warn('navigateToMemberProfile handler not implemented'),
  }),
});
